import { render, staticRenderFns } from "./CambiaMobileUtente.vue?vue&type=template&id=28ab3f7a&scoped=true&"
import script from "./CambiaMobileUtente.vue?vue&type=script&lang=js&"
export * from "./CambiaMobileUtente.vue?vue&type=script&lang=js&"
import style0 from "./CambiaMobileUtente.vue?vue&type=style&index=0&id=28ab3f7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab3f7a",
  null
  
)

component.options.__file = "CambiaMobileUtente.vue"
export default component.exports